/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { MilestoneEventFromToType, MilestoneEventRestService } from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';

import { Observable } from 'rxjs';

import { MilestoneEventListItem } from './milestone-event-list.model';

@Injectable()
export class MilestoneEventListBusinessService implements InitViewService {
  constructor(private restService: MilestoneEventRestService,
              private dictionaryService: DictionaryService,
              private gridLayoutService: GridLayoutService) {
  }

  initView(): any {
    return {
      dataSource: this.findAllAsDataSource(),
      gridLayout: this.gridLayoutService.get('milestoneEvents'),
      milestoneEventFromToType: this.dictionaryService.getByEnum(MilestoneEventFromToType),
    };
  }

  findAllAsDataSource(): SlicedDataSource<MilestoneEventListItem> {
    return this.restService.findAllAsDataSource();
  }

  remove(milestoneEvent: MilestoneEventListItem): Observable<void> {
    return this.restService.remove(milestoneEvent);
  }
}
